import { render, staticRenderFns } from "./MosaicoDrope.vue?vue&type=template&id=1201e04f&"
import script from "./MosaicoDrope.vue?vue&type=script&lang=js&"
export * from "./MosaicoDrope.vue?vue&type=script&lang=js&"
import style0 from "./MosaicoDrope.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports